/**
 * Faz o título de um `<InfoCard>` ser um cabeçalho de verdade.
 *
 * Sem isto, todo título de card do portal sai como `<span>`. A cadeia é esta:
 * o `CardHeader` do Material UI 4.12.4 monta o título com `component: "span"`
 * fixo, e o `InfoCard` do Backstage repassa `titleTypographyProps` sem default
 * próprio. O resultado é que o esqueleto de cabeçalhos de cada tela do portal
 * era o `<h1>` do `Header` e mais nada — quem navega por cabeçalho, que é como
 * um leitor de tela varre uma página, não alcançava nenhuma seção de conteúdo.
 * WCAG 1.3.1 (A) e 2.4.6 (AA).
 *
 * Por que só `component` entra aqui: no `CardHeader`, tanto `component` quanto
 * `variant: 'h5'` são aplicados ANTES do spread de `titleTypographyProps`.
 * Passar apenas `component` troca o elemento e deixa o `variant` intacto —
 * logo o tamanho e o peso do título continuam exatamente os mesmos. Esta
 * mudança não altera um pixel. Acrescentar `variant` aqui quebraria isso.
 *
 * Nível `h2` porque o `<h1>` da página já vem do `Header` do Backstage. Cards
 * são as seções de primeiro nível dentro dela; subseções dentro de um card
 * usam `h3` explicitamente no próprio `Typography`.
 */
export const PORTAL_CARD_TITLE_PROPS = { component: 'h2' } as const;
